import type { Mission } from '../missions.ts'

export const dhsSt: Mission = {
  id: "dhs-st",
  name: "DHS Science and Technology Directorate",
  short: "S&T",
  call: "Science & Technology",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.dhs.gov/science-and-technology",
  palette: {
    primary: "#005288",
    secondary: "#c41230",
    accent: "#0078ae",
  },
  colorSource: {
    kind: "site",
    url: "https://www.dhs.gov/science-and-technology",
  },
  motif: "atom",
  mission: {
    text: "The Science and Technology Directorate (S&T) delivers the tools, innovations, and technical expertise needed to make America safer.",
    url: "https://www.dhs.gov/science-and-technology/about-st",
  },
  fact: {
    text: "S&T’s in-house laboratories and sites span five states: Alabama, Florida, Maryland, New Jersey and New York.",
    url: "https://www.dhs.gov/science-and-technology/office-national-laboratories",
  },
  logo: {
    file: "public/logos/dhs-st.svg",
    source: "https://commons.wikimedia.org/wiki/File:DHS_Science_and_Technology_Directorate_Wordmark.svg",
  },
  identifier: {
    about: "https://www.dhs.gov/science-and-technology/about-st",
    accessibility: "https://www.dhs.gov/accessibility",
    foia: "https://www.dhs.gov/foia",
    noFear: "https://www.dhs.gov/homeland-security-no-fear-act-reporting",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.dhs.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/dhs-st-nbacc-lab.jpg",
        small: "/media/dhs-st-nbacc-lab-sm.jpg",
        alt: "Visitors look through an observation window into a containment laboratory where a researcher in protective gear works beside biosafety cabinets.",
        title: "Laboratory at the National Biodefense Analysis and Countermeasures Center, Fort Detrick, Maryland, June 16, 2025",
        creator: "Tia Dufour, U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:Department_of_Homeland_Security_(DHS)_tour_of_the_National_Biodefense_Analysis_and_Countermeasures_Center_(NBACC)_at_Fort_Detrick,_Maryland_on_June_16,_2025_04.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
